import React, { useState } from "react";
import { createExportCredential } from "../services/exportJobsService";

const labelStyle = { fontSize: 11, color: "#7b7b7b", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 };

// Write-only Vault credential input (DEV-2036 follow-up). Replaces the
// earlier "paste a Vault secret UUID" text field — the advertiser types the
// actual raw value (SFTP password / API key / CJ token) and explicitly clicks
// "Save credential" (never fired on every keystroke), which writes it to
// Vault via createExportCredential() and stores only the returned
// credential_secret_id. Vault secrets are write-only from the client's
// perspective: once configured, only a "Credential configured ✓" state is
// shown — the raw value is never re-fetched or re-displayed.
export function CredentialSecretField({ label = "Credential", credentialSecretId, onCredentialCreated, description, advertiserId }) {
  const [editing, setEditing] = useState(!credentialSecretId);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    if (!draft.trim()) { setError("Enter a value first."); return; }
    setSaving(true);
    setError(null);
    const { data, error: err } = await createExportCredential(advertiserId, draft, description);
    setSaving(false);
    if (err) { setError(err.message || "Failed to save credential."); return; }
    onCredentialCreated(data);
    setDraft("");
    setEditing(false);
  };

  return (
    <div>
      <div style={labelStyle}>{label}</div>
      {!editing && credentialSecretId ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "9px 12px", background: "#F0FFF4", border: "1px solid #86efac", borderRadius: 8, marginBottom: 10 }}>
          <span style={{ fontSize: 12, color: "#166534" }}>Credential configured ✓</span>
          <button type="button" onClick={() => setEditing(true)} style={{ background: "none", border: "none", color: "#F90091", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
            Replace
          </button>
        </div>
      ) : (
        <div style={{ marginBottom: 10 }}>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              type="password"
              autoComplete="new-password"
              value={draft}
              onChange={(e) => { setDraft(e.target.value); setError(null); }}
              placeholder="Enter password / API key / token"
              style={{ flex: 1, boxSizing: "border-box", padding: "10px 12px", background: "#FAFAFA", border: "1px solid #E2E2E2", borderRadius: 8, color: "#151515", fontSize: 13, outline: "none" }}
            />
            <button
              type="button"
              onClick={handleSave}
              disabled={saving || !draft.trim()}
              style={{ padding: "0 14px", background: saving || !draft.trim() ? "#F9009199" : "#F90091", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: saving || !draft.trim() ? "default" : "pointer", whiteSpace: "nowrap" }}
            >
              {saving ? "Saving…" : "Save credential"}
            </button>
          </div>
          {credentialSecretId && (
            <button
              type="button"
              onClick={() => { setEditing(false); setDraft(""); setError(null); }}
              style={{ marginTop: 6, background: "none", border: "none", color: "#7b7b7b", fontSize: 11, cursor: "pointer", padding: 0 }}
            >
              Cancel
            </button>
          )}
          {error && <div style={{ marginTop: 6, fontSize: 11, color: "#e53935" }}>{error}</div>}
          {!credentialSecretId && !error && (
            <div style={{ marginTop: 6, fontSize: 11, color: "#7b7b7b" }}>Stored securely in Vault — never shown again after saving.</div>
          )}
        </div>
      )}
    </div>
  );
}
